module.exports = __webpack_public_path__ + "static/swissdance-86e94c01dbdad103db90d0831adc923c.png";